import React from 'react';

const Auth0DetailsForm = ({auth0Details}) => {
    if (!auth0Details) {
        return <p>No Auth0 details provided.</p>;
    }

    return (
        <div style={styles.container}>
            <h4 style={styles.heading}>
                Auth Details
            </h4>

            <div style={styles.row}>
                <div style={styles.field}>
                    <label style={styles.label}>User ID</label>
                    <input
                        type="text"
                        value={auth0Details.user_id || ""}
                        readOnly
                        style={styles.input}
                    />
                </div>
            </div>

            <div style={styles.rowTwo}>
                <div style={styles.fieldWide}>
                    <label style={styles.label}>Email</label>
                    <input
                        type="email"
                        value={auth0Details.email || ""}
                        readOnly
                        style={styles.input}
                    />
                </div>

                <div style={styles.checkboxField}>
                    <label style={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            checked={auth0Details.email_verified || false}
                            readOnly
                            style={styles.checkbox}
                        />
                        Email Verified
                    </label>
                </div>
            </div>

            <div style={styles.rowTwo}>
                <div style={styles.fieldWide}>
                    <label style={styles.label}>Phone Number</label>
                    <input
                        type="tel"
                        value={auth0Details.phone_number || ""}
                        readOnly
                        style={styles.input}
                    />
                </div>

                <div style={styles.checkboxField}>
                    <label style={styles.checkboxLabel}>
                        <input
                            type="checkbox"
                            checked={auth0Details.phone_verified || false}
                            readOnly
                            style={styles.checkbox}
                        />
                        Phone Verified
                    </label>
                </div>
            </div>

            <div style={styles.rowTwo}>
                <div style={styles.field}>
                    <label style={styles.label}>Updated At</label>
                    <input
                        type="text"
                        value={
                            auth0Details.updated_at
                                ? new Date(auth0Details.updated_at).toLocaleString()
                                : ""
                        }
                        readOnly
                        style={styles.input}
                    />
                </div>

                <div style={styles.field}>
                    <label style={styles.label}>Last Login</label>
                    <input
                        type="text"
                        value={
                            auth0Details.last_login
                                ? new Date(auth0Details.last_login).toLocaleString()
                                : ""
                        }
                        readOnly
                        style={styles.input}
                    />
                </div>
            </div>

            <div style={styles.row}>
                <div style={styles.field}>
                    <label style={styles.label}>Login Count</label>
                    <input
                        type="number"
                        value={auth0Details.logins_count || 0}
                        readOnly
                        style={styles.input}
                    />
                </div>
            </div>
        </div>
    );
};
const styles = {
    container: {
        maxWidth: "900px",
        margin: "20px auto",
        padding: "32px",
        borderRadius: "18px",
        background: "#ffffff",
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
    },

    heading: {
        fontSize: "24px",
        fontWeight: "700",
        color: "#111827",
        marginBottom: "28px",
        borderBottom: "2px solid #f3f4f6",
        paddingBottom: "12px",
        letterSpacing: "0.3px",
    },

    row: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "22px",
    },

    rowTwo: {
        display: "grid",
        gridTemplateColumns: "2fr 1fr",
        gap: "20px",
        alignItems: "end",
        marginBottom: "22px",
    },

    field: {
        display: "flex",
        flexDirection: "column",
    },

    fieldWide: {
        display: "flex",
        flexDirection: "column",
    },

    label: {
        marginBottom: "8px",
        fontSize: "14px",
        fontWeight: "600",
        color: "#374151",
    },

    input: {
        width: "100%",
        padding: "12px 14px",
        borderRadius: "10px",
        border: "1px solid #d1d5db",
        backgroundColor: "#f9fafb",
        color: "#111827",
        fontSize: "14px",
        outline: "none",
        transition: "all 0.2s ease",
        boxSizing: "border-box",
    },

    checkboxField: {
        display: "flex",
        alignItems: "center",
        height: "46px",
        paddingLeft: "8px",
    },

    checkboxLabel: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        fontSize: "14px",
        fontWeight: "600",
        color: "#374151",
    },

    checkbox: {
        width: "18px",
        height: "18px",
        accentColor: "#16a34a",
        cursor: "default",
    },
};

export default Auth0DetailsForm;